<template>
  <!-- 预约弹窗 -->
  <div v-if="visible" class="subscribe-modal-overlay" @click="closeModal">
    <div class="subscribe-modal" @click.stop>
      <div class="modal-close" @click="$emit('close')">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12 4L4 12M4 4L12 12" stroke="#999" stroke-width="2" stroke-linecap="round" />
        </svg>
      </div>

      <div class="modal-content">
        <div class="modal-left">
          <div class="modal-bg-image">
            <img :src="subscribeBg" alt="预约背景" />
          </div>
          <div class="modal-text">
            我们很乐意为您提供以下帮助，以加深您对七鼠智服的了解
          </div>
          <div class="feature-list">
            <div class="feature-item">
              <img :src="tickIcon" alt="勾选" class="tick-icon" />
              <div class="feature-content">
                <div class="feature-title">快速上手</div>
                <div class="feature-desc">详尽的产品与功能介绍，帮助您快速上手七鼠智服</div>
              </div>
            </div>
            <div class="feature-item">
              <img :src="tickIcon" alt="勾选" class="tick-icon" />
              <div class="feature-content">
                <div class="feature-title">需求分析</div>
                <div class="feature-desc">专业的产品顾问人员，与您深入沟通使用需求</div>
              </div>
            </div>
            <div class="feature-item">
              <img :src="tickIcon" alt="勾选" class="tick-icon" />
              <div class="feature-content">
                <div class="feature-title">解决方案</div>
                <div class="feature-desc">针对所处行业与业务场景，打造专业的解决方案</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-right">
          <div class="form-title">预约演示</div>
          <form @submit.prevent="submitForm" class="subscribe-form">
            <div class="form-group">
              <label><span class="required">*</span>您的姓名</label>
              <input type="text" v-model="formData.name" placeholder="请输入您的姓名" required />
            </div>
            <div class="form-group">
              <label><span class="required">*</span>您的联系方式</label>
              <input type="tel" v-model="formData.phoneNumber" placeholder="请输入手机号" required />
            </div>
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? '提交中...' : '立即预约' }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subscribeBg from '../../../assets/img/com/pc/subscribe_bg.png'
import tickIcon from '../../../assets/img/com/pc/tick_icon.png'
import { subscribeApi } from '@/api/index.js'

export default {
  name: 'SubscribeModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subscribeBg,
      tickIcon,
      formData: {
        name: '',
        phoneNumber: ''
      },
      isSubmitting: false
    }
  },
  methods: {
    closeModal(event) {
      if (event.target === event.currentTarget) {
        this.$emit('close')
      }
    },

    submitForm() {
      if (this.formData.phoneNumber.length !== 11) {
        this.$message({
          message: '请输入有效的手机号码',
          type: 'danger',
          duration: 2000,
          customClass: 'high-z-index-message'
        })
        return
      }
      // 防止重复提交
      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true

      console.log('提交表单数据:', this.formData)
      subscribeApi(this.formData)
        .then(res => {
          console.log('message', this.$message);
          console.log('API响应:', res)
          if (res.code === 200) {
            this.$message({
              message: '预约成功，我们将尽快与您联系！',
              type: 'success',
              duration: 3000,
              customClass: 'high-z-index-message'
            })
            this.$emit('close')
            this.formData = {
              name: '',
              phoneNumber: ''
            }
          } else {
            this.$message({
              message: res.message || '预约失败，请稍后再试！',
              type: 'error',
              duration: 3000,
              customClass: 'high-z-index-message'
            })
          }
        })
        .catch(error => {
          this.$message({
            message: error.response.data?.message || `请求失败`,
            type: 'error',
            duration: 5000,
            customClass: 'high-z-index-message'
          })
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
// 预约弹窗样式
.subscribe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.subscribe-modal {
  width: 888px;
  height: 540px;
  background: #FFFFFF;
  border-radius: 8px;
  position: relative;
  overflow: hidden;

  .modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    z-index: 10;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 4px;
    }
  }

  .modal-content {
    display: flex;
    height: 100%;

    .modal-left {
      width: 356px;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;

      .modal-bg-image {
        width: 100%;
        height: 180px;
        margin-bottom: 28px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .modal-text {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        padding: 0 28px;
        margin-bottom: 24px;
      }

      .feature-list {
        padding: 0 28px;

        .feature-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 24px;

          .tick-icon {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            flex-shrink: 0;
          }

          .feature-content {
            width: 100%;

            .feature-title {
              font-weight: 500;
              font-size: 14px;
              line-height: 14px;
              color: #333333;
              margin-bottom: 4px;
            }

            .feature-desc {
              width: 100%;
              font-weight: 500;
              font-size: 12px;
              color: #666666;
              padding-bottom: 9px;
              border-bottom: 1px solid #DDDDDD;
            }
          }
        }
      }
    }

    .modal-right {
      flex: 1;
      // padding: 40px 48px;
      padding: 55px 46px 0 52px;
      display: flex;
      flex-direction: column;

      .form-title {
        font-weight: 800;
        font-size: 24px;
        // line-height: 24px;
        color: #333333;
        margin-bottom: 24px;
      }

      .subscribe-form {
        .form-group {
          margin-bottom: 22px;

          label {
            display: block;
            font-weight: 500;
            font-size: 20px;
            color: #333;
            margin-bottom: 12px;

            .required {
              color: #FF5143;
            }
          }

          input {
            width: 100%;
            height: 54px;
            border: 1px solid #D9D9D9;
            border-radius: 4px;
            padding: 0 16px;
            font-size: 16px;
            color: #333333;
            outline: none;
            transition: border-color 0.3s;

            &:focus {
              border-color: #0051FF;
            }

            &::placeholder {
              color: #CCCCCC;
            }

          }
        }

        .submit-btn {
          width: 100%;
          height: 64px;
          background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
          border: none;
          border-radius: 4px;
          font-weight: 500;
          font-size: 20px;
          color: #FFFFFF;
          cursor: pointer;
          transition: opacity 0.3s;
          margin-top: 51px;

          &:hover {
            opacity: 0.9;
          }

          &:active {
            opacity: 0.8;
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;

            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }
  }
}

// 全局样式，确保消息提示在弹窗之上
:global(.high-z-index-message) {
  z-index: 10000 !important;
}
</style>
